import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useContext } from "react";

import { AppContext } from "src/context/AppContext";
import RoutedButton from "src/newComponents/buttons/RoutedButton";
import NumbersSPC from "src/newComponents/NumbersSPC";

import TrustBox from "./Trustbox";

const getCtaButton = (isAuthenticated: boolean, freeTrial: boolean) => {
  if (isAuthenticated && freeTrial) {
    return {
      text: "Access Free Content",
      path: "/access-free-content/",
    };
  } else if (isAuthenticated) {
    return {
      text: "Explore Products",
      path: "/products/",
    };
  }
  return {
    text: "Join Us - It's FREE",
    path: "/join-us/",
  };
};

const LandingPageTopSPC = () => {
  const { isAuthenticated, freeTrial } = useContext(AppContext);

  const ctaButton = getCtaButton(isAuthenticated, freeTrial);

  return (
    <Stack
      sx={{
        alignItems: "center",
        mt: { md: 4, lg: 0 },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "2rem", sm: "2.2rem", md: "2.4rem" },
          maxWidth: { xs: "95%", sm: "90%", md: "80%" },
        }}
        style={{ textAlign: "center" }}
      >
        Start your
        <Box component="span" sx={{ color: "#009d47" }}>
          {` Foundation Training Programme `}
        </Box>
        with{" "}
        <Box component="span" sx={{ color: "primary.main" }}>
          {`Pre-Reg Shortcuts `}
        </Box>
      </Typography>

      <Typography sx={{ color: "text.secondary", mt: 2, mb: 4, textAlign: "center" }}>
        Enrol on our interactive Pharmacy Foundation Year Programme and succeed in your GPhC Registration Assessment
      </Typography>

      <Stack spacing={2} justifyContent="center" direction="row">
        <RoutedButton path="/about/" buttonColor="inherit" size="large" variant="outlined">
          About Us
        </RoutedButton>

        <RoutedButton path={ctaButton.path} buttonColor="inherit" size="large">
          {ctaButton.text}
        </RoutedButton>
      </Stack>

      <Divider sx={{ borderStyle: "dashed", mt: 3, mb: 2 }} style={{ borderColor: "transparent" }} />

      <NumbersSPC isLandingPage={true} />

      <Divider sx={{ borderStyle: "dashed", mt: 4, mb: 2 }} style={{ borderColor: "transparent" }} />

      <TrustBox />
    </Stack>
  );
};

export default LandingPageTopSPC;
